import { __exports as o } from "./td-longtail-vue-components277.js";
import k from "vue";
var v;
function y() {
  if (v) return o;
  v = 1;
  var a = k;
  a = "default" in a ? a.default : a;
  var c = "2.2.2", p = /^2\./.test(a.version);
  p || a.util.warn("VueClickaway " + c + " only supports Vue 2.x, and does not support Vue " + a.version);
  var r = "_vue_clickaway_handler";
  function s(t, e, u) {
    m(t, e);
    var _ = u.context, i = e.value;
    if (typeof i != "function") {
      process.env.NODE_ENV !== "production" && a.util.warn(
        "v-" + e.name + '="' + e.expression + '" expects a function value, got ' + i
      );
      return;
    }
    var d = !1;
    setTimeout(function() {
      d = !0;
    }, 0), t[r] = function(n) {
      var f = n.path || (n.composedPath ? n.composedPath() : void 0);
      if (d && (f ? f.indexOf(t) < 0 : !t.contains(n.target)))
        return i.call(_, n);
    }, e.arg ? document.documentElement.addEventListener(e.arg, t[r], !1) : document.documentElement.addEventListener("click", t[r], !1);
  }
  function m(t, e) {
    e.arg ? document.documentElement.removeEventListener(e.arg, t[r], !1) : document.documentElement.removeEventListener("click", t[r], !1), delete t[r];
  }
  var l = {
    bind: s,
    update: function(t, e, u) {
      e.value !== e.oldValue && s(t, e, u);
    },
    unbind: m
  }, E = {
    directives: { onClickaway: l }
  };
  return o.version = c, o.directive = l, o.mixin = E, o;
}
export {
  y as __require
};
